import * as React from "react";
import { render } from "react-dom";

import { initAnalytics } from "@common/analytics/ga4";
import { initGoogleTagManager } from "@common/analytics/gtm";
import { initFullStory } from "@common/util/fullstoryUtils";
import { startShakeSdk } from "@common/util/shakeSdkUtils";
import * as Sentry from "@sentry/react";

import App from "./App";

Sentry.init({
  dsn: "https://abf7eeb0980897cce107423115237891@o257007.ingest.sentry.io/4505634614083585",
  environment: process.env.APP_CONFIG_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["^https://dashboard-api.shakebugs.com/"],
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.4 : 1.0, // Capture 100% of the transactions, reduce in production!
  enabled: process.env.NODE_ENV !== "development",
});

startShakeSdk();
initFullStory();
initGoogleTagManager();
initAnalytics();

const rootEl = document.getElementById("root");

render(<App />, rootEl);
